import React, { useState, useEffect, useRef }from "react";

import styles from "./InputContainer.module.css";

const KEY_CODE = {
    backspace: 8,
    left: 37,
    right: 39
}

const InputContainer = ( { solution, isSolved } ) =>
{
    const [ inputFields, setInputFields ] = useState( [] );
    const [ isLoading, setLoading ] = useState(true); 

    const iRefs = useRef([]);
    iRefs.current = [];

    const handleChange = (event) => 
    {
        const elementId = parseInt(event.target.id);
        const nextElem = elementId+1;

        const newState = [...inputFields];

        newState[elementId].value = event.target.value;

        setInputFields(newState);

        if (event.target.value === "" )
        {
            iRefs.current[elementId].focus();
        }
        else
        {
            if ( iRefs.current[nextElem] !== undefined )
            {
                iRefs.current[nextElem].focus();
            }
        }

        const userInputResults = inputFields.map( input =>
        {
            return ( input.answer === input.value );
        });

        if ( !userInputResults.includes(false) )
        {
            isSolved(true);
            console.log("SOLVED!");
        }

        
    };

    const handleKeyboardInput = (event) =>
    {
        const index = parseInt(event.target.id);
        const prevIndex = index - 1;
        const nextIndex = index + 1;

        switch(event.keyCode)
        {
            case KEY_CODE.left:
                event.preventDefault();
                if ( iRefs.current[prevIndex] !== undefined )
                {
                    iRefs.current[prevIndex].focus();
                }
                break;
            case KEY_CODE.backspace:
                if ( iRefs.current[prevIndex] !== undefined )
                {
                    const newState = [...inputFields];
                    newState[index].value = "";
                    setInputFields(newState);

                    iRefs.current[prevIndex].focus();
                }
                break;
            
            case KEY_CODE.right:
                event.preventDefault();
                if (iRefs.current[nextIndex] !== undefined)
                {
                    iRefs.current[nextIndex].focus();
                }
                break;
            case KEY_CODE.enter:
                event.preventDefault();
            }
    }

    const handleFocus = event =>
    {
        event.target.select(event);
    };

    const addRefs = (element) =>
    {
        if(element && !iRefs.current.includes(element))
        {
            iRefs.current.push(element);
            if ( isLoading )
            {
                iRefs.current[0].focus();
                setLoading(false);
            }
        }
        
    }
    
    useEffect( () => 
    {
        setLoading(true);
        isSolved(false);
        setInputFields( solution.split("").map( (char, index ) => { return { id: index, answer: char, value:"" } } ) );
    }, [solution]);

    return (
        <div className={styles.root}>
            {
                inputFields.map( (data, index) => 
                {
                    return (
                        <>
                            <input
                                className={ ( data.answer === data.value ) ? styles.green : ( data.answer === " " ? styles.yellow : styles.grey ) }
                                id={index}
                                key={index+"_"}
                                value={data.value}
                                ref={addRefs}
                                onChange={handleChange}
                                onKeyDown={handleKeyboardInput}
                                onFocus={handleFocus}
                                maxLength={1}
                            ></input>
                            { ( data.answer === " " ) && <div className={styles.break} key={"_"+index}></div> } 
                        </>
                    )
                })
            }
        </div>
    )
}

export default InputContainer;